import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select'

export default {
  name: 'bag-details',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    DatePicker
  },
  props: [],
  data() {
    return {
      pageCount: 0,
      pageCount: 0,
      pageNo: 0,
      isLoadingSearch: false,
      shippingId: '',
      bagNo: '',
      app: '',
      apiName: '',
      fromDate: '',
      toDate: '',
      LogDetails: [],
      modalShow: false,
      modalShowReq: false,
      modalresdata: '',
      modalreqdata: '',
      Request: '',
      Response: '',
      isFromDateError: '',
      FromDateerrors: '',
      isToDateError: '',
      ToDateerrors: '',
      fromDatetoDate:'',
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  },
  mounted() {
    this.getlogdetails()
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    getlogdetails() {
      this.isLoadingSearch = true;
      this.fromDate = this.fromDatetoDate[0];
      this.toDate = this.fromDatetoDate[1];
      this.input = ({
        "offset": this.pageNo,
        "limit": 10,
        "shippingId": this.shippingId.trim(),
        "bagNo": this.bagNo.trim(),
        "app": this.app.trim(),
        "apiName": this.apiName.trim()
      });
      if (this.fromDate != "") {
        this.input.fromDate = this.fromDate;
      }
      if (this.toDate != "") {
        this.input.toDate = this.toDate;
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_stagetms + 'getLogDetails',
          //'url': 'http://localhost:8500/getLogDetails',
          'data': this.input,
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.errorCode == 0) {
            this.LogDetails = result.data.data;
            let totalRows = result.data.count
            if (totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(totalRows / 10);
            }
          } else {
            this.$alertify.error(result.data.msg);
            this.LogDetails = [];
          }
        }, error => {
          console.error(error)
        })
    },
    resetForm() {
      this.shippingId = ''
      this.bagNo = ''
      this.app = ''
      this.apiName = ''
      this.fromDatetoDate = ''
      this.fromDate = ''
      this.toDate = ''
      this.getlogdetails()
    },
    openResponseModal(data) {
      this.modalresdata = data
      var str = "Payload not found"
      if (this.modalresdata.Response[0]) {
        this.Response = this.modalresdata.Response[0]
      } else {
        this.Response = str
      }
      this.modalShow = true
    },
    closeResponseModal() {
      this.modalShow = false
    },
    openRequestModal(data) {
      this.modalreqdata = data
      var str = "Payload not found"
      if (this.modalreqdata.Request[0]) {
        this.Request = this.modalreqdata.Request[0]
      } else {
        this.Request = str
      }
      this.modalShowReq = true
    },
    closeRequestModal() {
      this.modalShowReq = false
    },
    //to get pagination
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1) * 10;
      this.getlogdetails();
    },
    onSubmitSearch: function() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/LogDetails/LogDetails.component.js